// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2vABq","imageUploader":"EGiftCard_imageUploader__BQMfV"};